import { render, staticRenderFns } from "./WebhookAction.vue?vue&type=template&id=feed3858&"
import script from "./WebhookAction.vue?vue&type=script&lang=ts&"
export * from "./WebhookAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports